import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configureCognito, validateCognitoConfig } from './config/cognito';

// Initialize Cognito configuration
if (validateCognitoConfig()) {
  configureCognito();
} else {
  console.warn('Cognito configuration is incomplete. Some authentication features may not work properly.');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);